export default "__VITE_ASSET__vhKcPv7R__"